import * as React from "react";

import * as _ from "lodash";

import { css, StyleSheet } from "aphrodite";
import IconHBRPause from "../../assets/img/icons/IconHBRPause";
import IconHBRPlay from "../../assets/img/icons/IconHBRPlay";
import text from "../../locale";
import theme from "../../theme";
import { isEdge, isIE, isIOS } from "../../utils/browser";
import { toMMSS } from "../../utils/time";
import AudioPlayerProgressBar from "../AudioPlayerProgressBar";

import "./PlayerSpecial.css";

interface IProps {
  feedbackEmail: string;
  itemUrl: string;
  noaUrl: string;
  title: string;
  subtitle: string;
  imageUrl?: string;
  color?: string;
  bgColor?: string;
  currentTime: number;
  length: number;
  speed: number;
  playing: boolean;
  onClickFeedback: () => void;
  onClickListenOnNoa: () => void;
  onSpeedUp: () => void;
  onSpeedDown: () => void;
  onTogglePlay: () => void;
  onChange: () => void;
  onClick: () => void;
}

class PlayerSpecial extends React.Component<IProps> {

  public renderFeedback = () => {
    const { feedbackEmail } = this.props;

    return (
      <a
        id="embed-audio-player-feedback"
        href={`mailto:${feedbackEmail}`}
        className={css(styles.footerLink, styles.marginRight)}
        onClick={this.props.onClickFeedback}
      >
        {text.player.FEEDBACK}
      </a>
    );
  }

  public renderListenOnNoa = () => {
    const { itemUrl } = this.props;

    return (
      <a
        id="embed-audio-player-listen-on-noa"
        href={itemUrl}
        target="_blank"
        className={css(styles.blueFooterLink)}
        onClick={this.props.onClickListenOnNoa}
        style={{ textDecoration: "none" }}
      >
        <span className={css(styles.footerLink)}>
          {text.player.LISTEN_ON}
        </span>
        <span className={css(styles.blueFooterLink)}>
          {text.player.NOA}
        </span>
      </a>
    );
  }

  public renderSpeedControl = () => {

    return (
      <div className={css(styles.speedControl)}>

        <span className={css(styles.speedTitle)} id="embed-audio-player-volume">
          {text.player.SPEED}&nbsp;&nbsp;
                </span>

        <a
          className={css(styles.noSelection, styles.speedIcon)}
          onClick={this.props.onSpeedUp}
          id="embed-audio-player-volume-up"
        >+</a>

        <span className={css(styles.speedSeparator)}>&nbsp; | &nbsp;</span>

        <a
          className={css(styles.noSelection, styles.speedIcon)}
          onClick={this.props.onSpeedDown}
          id="embed-audio-player-volume-down"
        >-</a>

      </div>
    );
  }

  public renderPlayAndPause = () => {
    const { playing } = this.props;

    return (
      <div
        id="embed-audio-player-playpause"
        className={css(styles.noSelection, styles.togglePlayButton)}
        onClick={this.props.onTogglePlay}
      >
        {playing && (
          <div className={css(styles.paddingPlayPauseButton)}>
            <IconHBRPause className={css(styles.playIcon)} />
          </div>
        )}
        {!playing && (
          <div className={css(styles.paddingPlayPauseButton)}>
            <IconHBRPlay className={css(styles.playIcon)} />
          </div>
        )}
      </div>
    );
  }

  public renderTime = () => {
    const { currentTime, length } = this.props;

    const audioLength = Math.round(length);
    const time = Math.round(currentTime);

    return (
      <span className={css(styles.time)}>
        <span id="embed-audio-player-time-playing" className={css(styles.fixedTimes)} style={{ textAlign: "right" }}>{toMMSS(time)}</span> &nbsp;/&nbsp; <span className={css(styles.fixedTimes)} style={{ textAlign: "left" }}>{toMMSS(audioLength)}</span>
      </span>
    );
  }

  public render() {
    const { color, bgColor, currentTime, length } = this.props;

    const audioLength = Math.round(length);
    const time = Math.round(currentTime);

    const bgStyle = bgColor ? { backgroundColor: `#${bgColor}` } : { background: `white` };

    return (
      <>
        <div>
          <div className={css(styles.container)} />
          <div className={css(styles.main)} style={bgStyle}>

            {/* MAIN CONTENT */}
            <div className={css(styles.line)}>
              <div className={css(styles.controls)}>
                <p className={css(styles.title)}>{text.player.LISTEN_TO_THIS_ARTICLE}</p>
                {this.renderSpeedControl()}
              </div>

              <div className={css(styles.content)}>
                <div className={css(styles.progressContent)}>
                  {this.renderPlayAndPause()}
                  <AudioPlayerProgressBar
                    max={audioLength}
                    value={time}
                    onChange={this.props.onChange}
                    onClick={this.props.onClick}
                    className={css(styles.progress)}
                    height={6}
                    color={color}
                    bgColor={"#F5F5F5"}
                    hideThumb={!isIOS}
                  />
                  {this.renderTime()}
                </div>
              </div>
            </div>

            <div className={css(styles.showOnTiny)}>
              <p className={css(styles.title)}>{text.player.LISTEN_TO_THIS_ARTICLE}</p>
            </div>

          </div>

          <div className={css(styles.links)}>
            {this.renderFeedback()}
            {this.renderListenOnNoa()}
          </div>

        </div>
      </>
    );
  }
}

// tslint:disable: object-literal-sort-keys
const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100vh",
    position: "absolute",
    zIndex: -10,
    backgroundColor: "white",
  },
  main: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      flexDirection: "column",
    },
    display: "flex",
    padding: "24px 24px 0px 24px",
  },
  title: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      paddingBottom: 7,
    },
    [`@media (min-width: ${theme.breakpoints.tiny}px)`]: {
      lineHeight: "14px",
    },
    whiteSpace: "nowrap",
    paddingRight: 10,
    fontSize: 16,
    fontWeight: 500,
    color: theme.embedTitle,
    marginBottom: 0,
    fontFamily: "GT-America-Standard-Bold",
  },
  showOnTiny: {
    [`@media (min-width: ${theme.breakpoints.tiny}px)`]: {
      display: "none",
    },
  },
  image: {
    [`@media (max-width: ${theme.breakpoints.small}px)`]: {
      display: "none",
    },
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    width: 200,
    height: 200,
  },
  blueFooterLink: {
    color: theme.tertiaryColor,
    fontSize: 12,
    fontFamily: "GT-America-Standard-Light",
  },
  footerLink: {
    fontSize: 12,
    color: "#282828",
    textDecoration: "none",
    fontFamily: "GT-America-Standard-Light",
  },
  marginRight: {
    marginRight: 15,
  },
  controls: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      display: "none",
    },
    display: "flex",
    flexDirection: "column",
    padding: "0px 20px 0px 0px",
  },
  content: {
    [`@media (min-width: ${theme.breakpoints.tiny}px)`]: {
      marginTop: -5,
    },
    flex: 1,
  },
  togglePlayButton: {
    width: isIE ? 45 : 25,
    height: 30,
    display: "flex",
    borderRadius: 90,
    marginRight: 5,
    marginLeft: 1,
    justifyContent: "center",
    flexDirection: "column",
    cursor: "pointer",
    textAlign: "center",
  },
  playIcon: {
    marginTop: isIE ? -10 : "initial",
    transform: "scale(1, 1.25)",
    width: 15,
    height: 25,
  },
  progress: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      marginTop: 6,
    },
    borderTop: !isIE ? "1px solid #C8C8C8" : "initial",
    marginTop: isIE ? -4 : 8,
    width: "100%",
  },
  time: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      padding: "0px 0px 0px 10px",
    },
    marginTop: isIE ? -5 : "initial",
    marginRight: isEdge ? 15 : "initial",
    padding: "0px 0px 0px 10px",
    fontSize: 16,
    color: "#787878",
    whiteSpace: "nowrap",
    fontFamily: "GT-America-Standard-Light",
  },
  progressContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  noSelection: {
    "-webkit-user-select": "none",
    "-moz-user-select": "none",
    "-khtml-user-select": "none",
    "-ms-user-select": "none",
  },
  paddingPlayPauseButton: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      paddingLeft: "initial",
      paddingBottom: 2,
    },
    paddingLeft: 6,
  },
  links: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "6px 5px 0 0",
    fontFamily: "GT-America-Standard-Light",
  },
  speed: {
    [`@media (max-width: ${theme.breakpoints.tiny - 1}px)`]: {
      fontSize: 10,
      paddingTop: 6,
    },
    color: theme.embedTitle,
    fontWeight: 600,
    paddingRight: 10,
    fontSize: 13,
    paddingTop: 5,
  },
  speedControl: {
    display: "flex",
    alignItems: "center",
  },
  speedTitle: {
    color: "#787878",
    fontSize: 12,
    fontFamily: "GT-America-Standard-Light",
  },
  speedSeparator: {
    fontSize: 12,
    color: "#787878",
    fontWeight: 100,
  },
  speedIcon: {
    fontSize: 18,
    color: "#787878",
    fontWeight: 700,
    cursor: "pointer",
    fontFamily: "GT-America-Standard-Bold",
  },
  line: {
    width: "100%",
    display: "flex",
  },
  fixedTimes: {
    display: "inline-block",
    width: 45,
  },
});

export default PlayerSpecial;
